export default function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/rectToClientRect.js
// module id = Pn9s
// module chunks = 1